import React, { useState } from "react";
import { useInView } from "react-intersection-observer";
import { ShinyText } from "./Home";
import WritingTone from "../../Asset/Writing Tone.svg";
import FixGrammer from "../../Asset/Fix Grammer.svg";
import TranscriptOnly from "../../Asset/Transcript Only.svg";
import AskGPT from "../../Asset/Ask GPT.svg";
import DownloadButton from "../../component/DownloadButton/DownloadButton";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { ReactSVG } from "react-svg";

const promptsfaqs = [
  {
    icon: WritingTone,
    question: "Writing Tone",
    answer:
      "Quickly switch between professional and casual tones. Write in a polished style for work or a relaxed, friendly style for casual chats, all with a single click.",
  },
  {
    icon: FixGrammer,

    question: "Fix Grammer",
    answer:
      "Format your text neatly into clean paragraphs or bullet points. You can also fix grammar, punctuation, and automatically turn written numbers into symbols, like “five dollars” into $5, without changing your tone or meaning.",
  },
  {
    icon: TranscriptOnly,

    question: "Transcript Only",
    answer:
      "Convert spoken input into text exactly as it was said, with no corrections, formatting, or extra processing.",
  },
  {
    icon: AskGPT,

    question: "Ask GPT",
    answer:
      "Use an intelligent conversational assistant that responds naturally to your messages, making it easy to ask questions or continue your thoughts.",
  },
];

const PromptsSection = () => {
  const { ref: videoRef, inView: videoView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: headingRef, inView: headingView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const { ref: buttonRef, inView: buttonView } = useInView({
    triggerOnce: true,
    threshold: 0.5,
  });
  const [openPromptIndex, setOpenPromptIndex] = useState(null);

  const handleToggle = (index) => {
    setOpenPromptIndex(index === openPromptIndex ? null : index);
  };
  return (
    <div className="flex md:flex-row flex-col items-center md:gap-2 gap-10 xl:pt-10 lg:pt-8 md:pt-6 xl:pb-10 lg:pb-8 md:pb-6 lg:px-10 md:px-6 z-[5] bg-white">
      <div className=" flex-1 flex flex-col md:items-start items-center xl:gap-5 lg:gap-4 gap-3">
        <div
          ref={headingRef}
          className={`${
            headingView
              ? `animate-slideUp z-[3] anim-preserve`
              : "opacity-0 z-0"
          } xl:text-[3.125rem] lg:text-[2.8rem] md:text-[2.4rem] text-[2.625rem] md:text-left text-center tracking-tighter leading-tight  font-jakarta font-bold`}
        >
          <ShinyText
            text="Prompts "
            speed={5}
            className="custom-class text-wrap"
          />
          That Work Like You Do
        </div>
        <div className=" xl:text-[1.438rem] z-[4] relative bg-white lg:text-[1.2rem] md:text-[1.15rem] text-[1.313rem] md:text-left text-center leading-snug text-[#00000099] font-inter">
          Zero Typing keeps your words as you said them, tidied. When you want
          them changed, ask. Dictate and rewrite text with AI: fix grammar,
          change the tone of a message, shorten it, or make it formal. Use the
          ready-made prompts or build your own.
        </div>
        <div className=" font-inter md:block hidden">
          {promptsfaqs.map((faq, index) => (
            <PromptsFAQs
              key={index}
              index={index}
              icon={faq.icon}
              question={faq.question}
              answer={faq.answer}
              isOpen={index === openPromptIndex}
              onClick={() => handleToggle(index)}
            />
          ))}
        </div>
        <span className=" text-black lg:text-[1.125rem] text-[1.1rem] font-inter md:block hidden">
          You can also build your own custom prompts to match your exact writing
          style.
        </span>
        <div className="md:block hidden">
          <DownloadButton ref={buttonRef} view={buttonView} />
        </div>
      </div>
      <div className=" flex-1 flex justify-center items-center">
        <video
          ref={videoRef}
          className={`${
            videoView ? `animate-slideUp anim-preserve z-[3]` : "opacity-0 z-0"
          }  lg:w-[85%] md:w-[90%] w-full xl:rounded-3xl rounded-2xl `}
          src="https://pub-25f4599302a64a3dab9e149b2b5f9a0f.r2.dev/videos/MANAGE%20PROMPTS.mp4"
          autoPlay
          loop
          muted
          playsInline
          webkit-playsinline="true"
          preload="metadata"
        />
      </div>
    </div>
  );
};

const PromptsFAQs = ({ icon, question, answer, index, isOpen, onClick }) => {
  return (
    <div
      className={`${
        index === 0 ? "" : "border-t border-[#CECECE] "
      } overflow-hidden py-2 `}
    >
      <div className="flex items-center justify-between w-full lg:py-2 py-1 text-[1rem] font-semibold text-black font-inter text-left">
        <span className=" flex items-center gap-2">
          <ReactSVG
            src={icon}
            beforeInjection={(svg) => {
              svg.setAttribute("class", "w-5 h-auto");
            }}
          />
          {question}
        </span>

        <button onClick={onClick} className="w-5 h-5 relative text-[#CECECE]">
          <span
            className={`absolute inset-0 transition-all duration-300 ease-in-out ${
              isOpen ? "opacity-0 scale-90" : "opacity-100 scale-100"
            }`}
          >
            <IoIosArrowDown className="w-5 h-5" />
          </span>
          <span
            className={`absolute inset-0 transition-all duration-300 ease-in-out ${
              isOpen ? "opacity-100 scale-100" : "opacity-0 scale-90"
            }`}
          >
            <IoIosArrowUp className="w-5 h-5" />
          </span>
        </button>
      </div>

      <div
        className={` overflow-hidden transition-all duration-300 ease-in-out ${
          isOpen ? "max-h-40 opacity-100 py-2" : "max-h-0 opacity-0"
        }`}
      >
        <p className="text-sm text-black">{answer}</p>
      </div>
    </div>
  );
};

export default PromptsSection;
